<template>
  <div class="form-group-radio">
    <label class="form-radio">
      <input
        :name="name"
        v-bind="$attrs"
        v-model="model"
        :value="radioValue"
        type="radio"
      />
      <span class="form-radio__text">{{ text }}</span>
    </label>
    <span class="form-error" v-if="errorMessage">{{ errorMessage }}</span>
  </div>
</template>

<script>
export default {
  name: "FormRadio",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    radioValue: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    errorMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import "src/styles/helpers/variables";

.form-group-radio {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}

.form-radio {
  display: block;

  input {
    position: absolute;
    z-index: -1;
    opacity: 0;

    &:checked + span::after {
      opacity: 1;
    }
  }

  &__text {
    position: relative;
    display: block;
    min-width: 15px;
    min-height: 15px;
    padding: 0 0 0 30px;
    font-size: 11px;
    line-height: 15px;
    color: currentColor;
    cursor: pointer;
    transition: $base-transition;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 15px;
      height: 15px;
      background: $border-color;
      border: 1px solid $white;
      box-sizing: border-box;
      box-shadow: 0 0 9.6px rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      transition: $base-transition;
    }

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 15px;
      height: 15px;
      background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.5 4.15506L4.36364 7.01221L8.5 1.01221' stroke='%23333333' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 10px 8px;
      opacity: 0;
      transition: $base-transition;
    }
  }
}

.form-error {
  display: block;
  padding-left: 32px;
  margin-top: 5px;
  font-style: normal;
  font-weight: 300;
  color: $main-brand-color;
}
</style>
